exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".online-otp-container {\n  font-size: 14px;\n  line-height: 20px;\n  font-family: 'SFUIText-Regular'; }\n\n.online-otp-container-content {\n  padding-bottom: 20%; }\n\n.online-otp-photo img {\n  width: 100%; }\n\n.online-otp-description-content {\n  padding: 10px; }\n  .online-otp-description-content .bold {\n    font-family: 'SFUIText-Bold'; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/OnlineOtp/Home/HomeView.scss
// module id = 307
// module chunks = 0